var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4453,
    cy: 51.4453,
    r: 51.4453,
    fill: "url(#paint0_linear_1042_2169)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1042_2169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 103
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4453,
    cy: 51.4453,
    r: 51.4453,
    fill: "url(#paint1_linear_1042_2169)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1042_2169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.2266,
    y: 27.6406,
    width: 45.0279,
    height: 94.4377,
    rx: 3.22454,
    fill: "url(#paint2_linear_1042_2169)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.6328,
    y: 22.3516,
    width: 45.0279,
    height: 94.4377,
    rx: 3.22454,
    fill: "url(#paint3_linear_1042_2169)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.2734,
    y: 29,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4609,
    y: 29,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8359,
    y: 29,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.2109,
    y: 39.5645,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0859,
    y: 38.9531,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4609,
    y: 38.9531,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6484,
    y: 38.9531,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8359,
    y: 38.9531,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73.2109,
    y: 49.5176,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0859,
    y: 49.2676,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6484,
    y: 49.2676,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8359,
    y: 49,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8359,
    y: 59.2227,
    width: 5.73047,
    height: 5.73047,
    fill: "#E5EFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1042_2169",
    x1: 51.4453,
    y1: 0,
    x2: 51.4453,
    y2: 102.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1042_2169",
    x1: 51.4453,
    y1: 0,
    x2: 51.4453,
    y2: 102.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1042_2169",
    x1: 57.9194,
    y1: 54.3812,
    x2: 62.1554,
    y2: 121.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1042_2169",
    x1: 43.1468,
    y1: 22.3516,
    x2: 43.1468,
    y2: 116.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024FCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/사례1.b7180983435e3619a7223c1207339c1d.svg";
export { ForwardRef as ReactComponent };